// Shared word-frequency tokenizer used by LabelCloudBody and TopWordsBody.
// Whitespace split + punctuation strip + lowercase, with a short English
// stop-word list. Multi-word concepts are not preserved.

export interface ValueRowLike { freeform_value: string | null }

export interface Token { word: string; count: number; }

const STOP_WORDS = new Set([
  'the','a','an','and','or','but','if','of','in','on','at','to','for','from','by',
  'with','as','is','are','was','were','be','been','being','have','has','had','do',
  'does','did','will','would','should','could','can','may','might','must','shall',
  'this','that','these','those','i','you','he','she','it','we','they','my','your',
  'his','her','its','our','their','me','him','us','them','what','which','who','whom',
  'whose','where','when','why','how','not','no','yes','so','up','down','out','about',
  'than','then','there','here','also','just','too','very','more','most','some','any',
  'all','one','two','3','4','5','am','pm','today','yesterday','tomorrow',
]);

const MIN_LEN = 3;

export function tokenize(rows: ValueRowLike[], maxTokens = 80): Token[] {
  const counts = new Map<string, number>();
  for (const r of rows) {
    const text = r.freeform_value;
    if (!text) continue;
    const cleaned = text.toLowerCase().replace(/[^\p{L}\p{N}\s]+/gu, ' ');
    for (const tok of cleaned.split(/\s+/)) {
      if (tok.length < MIN_LEN) continue;
      if (STOP_WORDS.has(tok)) continue;
      counts.set(tok, (counts.get(tok) ?? 0) + 1);
    }
  }
  const all = [...counts.entries()].map(([word, count]) => ({ word, count }));
  all.sort((a, b) => b.count - a.count || a.word.localeCompare(b.word));
  return all.slice(0, maxTokens);
}
